/* AxisBottom.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./AxisBottom.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { element } from '../../../core/elements';
import { defaultTextHTMLProps } from '../constants/default_text';
import Orientation from '../constants/orientation';
import getAxisDataType from '../utils/getAxisDataType';
import getTickFormatter from '../utils/getTickFormatter';
import { AxisLine, axisLineStroke } from './AxisLine';
import { Tick } from './Tick';
import { TickText } from './TickText';
import { useAxisTicks } from './useAxisTicks';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const bottomTickLabelProps = {
  color: "var(--ds-text-subtlest, grey)",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
  fontSize: 12,
  textAlign: 'center'
};
const tickLength = 8;
const orientation = Orientation.bottom;
export const AxisBottomTick = element(Tick);
export const AxisBottomLine = element(_ref => {
  let {
    width,
    top,
    hide
  } = _ref;
  return /*#__PURE__*/_jsx(AxisLine, {
    hide: hide,
    style: {
      borderBottom: `${axisLineStroke} solid 2px`,
      width: `${width}px`,
      position: 'absolute',
      top: `${top}px`
    }
  });
});

/**
 * Each text element that is rendered by an axis.
 */

export const AxisBottomText = element(_ref2 => {
  let {
    width,
    formatter,
    truncate,
    singleline,
    children,
    transform
  } = _ref2;
  return /*#__PURE__*/_jsx(TickText, {
    style: {
      width,
      transform
    },
    formatter: formatter,
    truncate: truncate,
    singleline: singleline,
    children: children
  });
});
function AxisBottom(_ref3) {
  let {
    scale,
    numTicks,
    tickValues,
    top,
    left,
    rangePadding,
    hideZero,
    label,
    hide
  } = _ref3;
  if (hide) return null;
  const {
    ticks
  } = useAxisTicks({
    scale,
    numTicks,
    tickValues,
    orientation,
    rangePadding,
    hideZero,
    tickLength
  });
  const TickTextsComponent = ticks.map(_ref4 => {
    let {
      value,
      index,
      from,
      to
    } = _ref4;
    const formatter = getTickFormatter(scale);
    return /*#__PURE__*/_jsx("div", {
      style: {
        left: `${to.x}px`
      },
      className: ax(["_yyhykb7n _1ii7kb7n _kqswh2mm _1bsbidpf _syaz13nv _ect41wi2 _1wyb1crf _y3gn1h6o"]),
      children: /*#__PURE__*/_jsx(AxisBottomText, {
        width: Number(scale.range()[1]) / ticks.length,
        formatter: formatter,
        truncate: getAxisDataType(scale) === 'string',
        transform: "translateX(-50%)",
        children: value
      })
    }, `axis-bottom-text-${index}-${value}-${from.toArray()}-${to.toArray()}`);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        gridArea: 'plot'
      },
      children: /*#__PURE__*/_jsx(AxisBottomLine, {
        width: left,
        top: top
      })
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        gridArea: 'axis-bottom',
        display: 'grid',
        gridTemplateRows: 'auto min-content'
      },
      "data-axis-type": "axis-bottom",
      children: [/*#__PURE__*/_jsx("div", {
        className: ax(["_1e0c11p5 _yv0ehkll _2z05hkll _ca0q1crf _lcxvglyw"]),
        children: TickTextsComponent
      }), label && /*#__PURE__*/_jsx("div", {
        style: {
          paddingTop: '8px',
          width: '100%',
          textAlign: 'center',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          ...defaultTextHTMLProps
        },
        children: label
      })]
    })]
  });
}
const _AxisBottom = element(AxisBottom);
export { _AxisBottom as AxisBottom };